/* ==========================================================================
   Header dropdowns open on hover.

   Dawn's <header-menu> is a <details> that opens on CLICK. The client wants
   the Wholesale menu to "just automatically come down" when the pointer
   reaches it, the way most storefront menus do. This adds that without
   touching Dawn's element: pointer in -> set `open`, pointer out -> remove it.

   Setting the attribute is enough. Dawn listens to the <details> `toggle`
   event, not to the click, so its own bookkeeping (aria-expanded, the header
   "preventHide" flag, the open animation) all still runs.

   Hover only exists on a device with a fine pointer, so this is gated on
   that media query; on a phone or tablet the menu keeps opening on tap, and
   a mouse user can still click too. The small delay on leaving is what lets
   the pointer travel from the trigger down into the list without the list
   vanishing halfway.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__gioHoverMenu) return;
  window.__gioHoverMenu = true;

  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var timers = new WeakMap();

  function details(el) {
    var menu = el && el.closest && el.closest('header-menu');
    return menu ? menu.querySelector('details') : null;
  }

  document.addEventListener(
    'mouseover',
    function (event) {
      if (!hoverable.matches) return;
      var d = details(event.target);
      if (!d) return;
      window.clearTimeout(timers.get(d));
      if (!d.hasAttribute('open')) {
        d.setAttribute('open', '');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      }
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      if (!hoverable.matches) return;
      var d = details(event.target);
      if (!d) return;
      // Still inside the same menu (moving from trigger to list)? Then nothing.
      if (event.relatedTarget && d.contains(event.relatedTarget)) return;
      timers.set(
        d,
        window.setTimeout(function () {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }, 180)
      );
    },
    true
  );
})();
